import React, { useCallback, useEffect, useMemo } from 'react';
import _ from 'underscore';
import { Constants, TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { TaxDialog } from '@bingads-webui-cc-react/dialogs';
import { useValidationContext } from '../validation-context';

const {
  getTaxValue, normalizeTaxExemptionCertVerifiedResult,
} = TaxUtils;
const {
  CountryCode, VatStatusEnum, TaxInfo, TaxExemptionCertVerifiedResult,
} = Constants;
const { ConfirmTaxCertificateDialog } = TaxDialog;

const getIsTaxExemptionCertVerified = ({ taxData }) => getTaxValue(_.get(taxData, 'data'), TaxInfo.IsTaxExemptionCertVerified);

export const TaxCertValidation = () => {
  const {
    i18n,
    getAblInfoData,
    mtAblInfo,
    onCancel,
    onContinue,
  } = useValidationContext();

  const { countryCode, taxData } = getAblInfoData();
  const isMtTaxCertPendingReview = useMemo(() => _.get(mtAblInfo, ['taxData', 'taxCertification', 'Status']) === VatStatusEnum.Pending, [mtAblInfo]);
  const normalizedTaxExemptionCertVerifiedResult = useMemo(() => normalizeTaxExemptionCertVerifiedResult(getIsTaxExemptionCertVerified({ taxData })), [taxData]);
  const isTaxCertReviewed = useMemo(() => normalizedTaxExemptionCertVerifiedResult !== TaxExemptionCertVerifiedResult.NotSet, [normalizedTaxExemptionCertVerifiedResult]);
  const isRejection = useMemo(() => normalizedTaxExemptionCertVerifiedResult === TaxExemptionCertVerifiedResult.Reject, [normalizedTaxExemptionCertVerifiedResult]);
  const showDialog = useMemo(
    () => countryCode === CountryCode.CO
      && isMtTaxCertPendingReview
      && isTaxCertReviewed,
    // we should only calculate it once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (!showDialog) {
      onContinue();
    }
  // we should only call this once when component did mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onGoBackClick = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return showDialog
    ? (
      <ConfirmTaxCertificateDialog
        i18n={i18n}
        onConfirmClick={onContinue}
        onGoBackClick={onGoBackClick}
        isRejection={isRejection}
        show
      />
    )
    : null;
};
